module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Thanks")]), _vm._v(" "), _c('h2', [_vm._v("VUX 参考或者使用了以下开源项目的代码")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue"
    }
  }, [_vm._v("Vue")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/weui/weui"
    }
  }, [_vm._v("WeUI")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/frozenui/frozenui"
    }
  }, [_vm._v("FrozenUI")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/ant-design/ant-design"
    }
  }, [_vm._v("Ant Design")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://github.com/ant-design/ant-design-mobile"
    }
  }, [_vm._v("Ant Design Mobile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/huxiaoqi567/xscroll"
    }
  }, [_vm._v("XScroll")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/driftyco/ionic"
    }
  }, [_vm._v("Ionic")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/sdc-alibaba/SUI-Mobile"
    }
  }, [_vm._v("SUI Mobile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/dimsemenov/PhotoSwipe"
    }
  }, [_vm._v("PhotoSwipe")])])]), _vm._v(" "), _c('h2', [_vm._v("工具框架")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("世界上最好的语言 "), _c('code', [_vm._v("JavaScript")])]), _vm._v(" "), _c('li', [_vm._v("啥都能做的前端构建工具 "), _c('a', {
    attrs: {
      "href": "https://webpack.js.org/"
    }
  }, [_vm._v("Webpack")])]), _vm._v(" "), _c('li', [_vm._v("简单好用的文档展示工具 "), _c('a', {
    attrs: {
      "href": "https://docute.js.org/#/"
    }
  }, [_vm._v("Docute")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bd086e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4bd086e6"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/thanks-34.vue
// module id = 2222
// module chunks = 399